import React from 'react';
import AdminLayout from "@/components/layout/admin/adminLayout";
import TableSearch from "@/components/table/tableSearch";
import {toFaNumberFormat} from "@/lib/utils/number";
import {convertToJalaliWithFormat} from "@/lib/utils/date";
import {Button} from "antd";
import {Link, useNavigate} from "react-router-dom";
import {sprintf} from "@/lib/utils/sprintf";
import {URLS} from "@/lib/urls";
import {useApiSearchAdminDiscounts} from "@/api/discount";
import DiscountStatusEnumComponent from "@/components/EnumComponents/DiscountStatusEnumComponent";
import RenderIf from "@/components/render-if";
import PermList from "@/lib/helper/PermList";
import {Can, hasPermissionLink} from "@/components/can/Can";

function AdminDiscountListPage(props) {
    const navigate = useNavigate();

    /**
     * academy_id
     * code
     * generate_code_by
     * title
     * type
     * discount_mode
     * percent
     * amount
     * max_amount
     * category
     * user_description
     * allow_gender
     * total_capacity
     * capacity_per_user
     * usage_status
     * publish_at
     * expired_at
     * finished_at
     * parent_id
     * status
     * created_at
     * updated_at

     */
    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'عنوان',
            dataIndex: 'title',
            key: 'title',
        },

        {
            title: 'مقدار',
            dataIndex: 'discount_value',
            key: 'discount_value',
            render: (text, record) => {
                if (record.discount_mode === 'percent') {
                    return (<>{(record?.percent ?? 0) + '%'}
                        <RenderIf condition={record.max_amount}>
                            <span
                                className={'text-xs px-2 text-gray-400'}> تا سقف {toFaNumberFormat(record.max_amount)} تومان </span>
                        </RenderIf>
                    </>)
                }

                if (record.discount_mode === 'amount') {
                    return toFaNumberFormat(record?.amount ?? 0) + ' تومان ';
                }
            }
        },
        {
            title: 'میزان استفاده',
            dataIndex: 'usages_count',
            key: 'usages_count',
            render: (text, record) => {
                if (!record?.usages_count) {
                    return '-'
                }

                return (<Link to={sprintf(URLS.admin.discount.edit, {id: record.id}) + '#usage'}>
                    {toFaNumberFormat(record?.usages_count ?? 0) + ' بار '}
                </Link>)
            }
        },

        {
            title: 'وضعیت',
            dataIndex: 'status',
            key: 'status',
            render: (text) => <DiscountStatusEnumComponent text={text}/>
        },

        {
            title: 'تاریخ ثبت',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, record) => {

                return convertToJalaliWithFormat(text, 'jYYYY/jMM/jDD HH:mm:ss')
            }
        },


        {
            title: ' ',
            dataIndex: 'id',
            key: 'id',
            render: (text, record) => {
                return (<Link
                    to={hasPermissionLink(PermList.DISCOUNT_EDIT, sprintf(URLS.admin.discount.edit, {id: record.id}))}>
                    <Button size={'small'} variant={'filled'}
                            color={'primary'}>ویرایش</Button>
                </Link>)
            }
        },
    ];
    return (
        <AdminLayout backTo={URLS.admin.dashboard} pageTitle={'لیست کد‌های تخفیف'}>

            <TableSearch
                searchInput={true}
                addButton={
                    <div className={'flex justify-end'}>
                        <Can permission={PermList.DISCOUNT_ADD}>
                            <Button
                                color={'primary'}
                                variant={'solid'}
                                size={'medium'}
                                onClick={() => navigate(URLS.admin.discount.create)}>
                                ساخت کد تخفیف
                            </Button>
                        </Can>

                    </div>
                }
                apiFn={useApiSearchAdminDiscounts}
                columns={columns}
                scroll={{x: true}}
                responsive={true}
            />

        </AdminLayout>
    );
}

export default AdminDiscountListPage;